import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

interface ProjectCollaboratorsProps {
  members: { id: string; name: string }[]
  max?: number
}

export function ProjectCollaborators({ members, max = 5 }: ProjectCollaboratorsProps) {
  const visible = members.slice(0, max)
  const remaining = members.length - max

  return (
    <TooltipProvider>
      <div className="flex items-center whitespace-nowrap">
        {visible.map((member, i) => (
          <Tooltip key={member.id}>
            <TooltipTrigger asChild>
              <Avatar
                className="h-7 w-7 border-2 border-background"
                style={{ marginLeft: i > 0 ? '-0.5rem' : 0 }}
              >
                <AvatarFallback className="bg-accent-soft text-xs text-background">
                  {getInitials(member.name)}
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent>
              <p>{member.name}</p>
            </TooltipContent>
          </Tooltip>
        ))}
        {remaining > 0 && (
          <span className="ml-2 text-sm text-muted-foreground">+{remaining}</span>
        )}
      </div>
    </TooltipProvider>
  )
}
